import { eventChannel } from 'redux-saga';
import { call, cancelled, put, take } from 'redux-saga/effects';
import { collection, onSnapshot, query } from 'firebase/firestore';
import { db } from 'config/firebase';
import {
    platformMaintenanceActive,
    platformMaintenanceInactive
} from '../actions/PlatformMaintenance';

const WEB_PLATFORM = 'web';

function isWebMaintenanceActive(maintenance) {
    if (maintenance?.active !== true || !Array.isArray(maintenance?.platforms)) {
        return false;
    }

    return maintenance.platforms
        .map(platform => String(platform).toLowerCase())
        .includes(WEB_PLATFORM);
}

function createPlatformMaintenanceChannel() {
    const q = query(collection(db, 'platform_maintenance'));

    return eventChannel(emit => {
        const unsubscribe = onSnapshot(q, snapshot => {
            const activeDocs = snapshot.docs
                .map(doc => doc.data())
                .filter(isWebMaintenanceActive);
            emit(activeDocs.length > 0);
        });

        return () => unsubscribe();
    });
}

export function* platformMaintenanceWatch() {
    const maintenanceChannel = yield call(createPlatformMaintenanceChannel);

    try {
        while (true) {
            const isActive = yield take(maintenanceChannel);

            if (isActive) {
                yield put(platformMaintenanceActive());
            } else {
                yield put(platformMaintenanceInactive());
            }
        }
    } catch (error) {
        console.error('Error watching platform_maintenance:', error);
    } finally {
        if (yield cancelled()) {
            maintenanceChannel.close();
        }
    }
}
